// extracted by mini-css-extract-plugin
export var actions = "_la-d";
export var benefitCard = "_la-a";
export var benefitIcon = "_la-b";
export var benefitLabel = "_la-c";
export var benefits = "_la-9";
export var bodyText = "_la-8";
export var closeButton = "_la-2";
export var content = "_la-3";
export var eyebrow = "_la-4";
export var heading = "_la-5";
export var image = "_la-f";
export var imagePanel = "_la-e";
export var modal = "_la-0";
export var shell = "_la-1";
export var title = "_la-6";
export var titleOffer = "_la-7";